import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ExportarDropbox } from '../models/exportar-dropbox.model';
import { ExportarDropboxService } from '../services/exportar-dropbox.service';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-exportar-dropbox-edit',
  templateUrl: './exportar-dropbox-edit.component.html',
  styleUrls: ['./exportar-dropbox-edit.component.scss']
})
export class ExportarDropboxEditComponent extends BaseFormComponent<ExportarDropbox> implements OnInit {

  actionLabel: string = 'Novo';
  typeList: any[];
  executionList: any[];

  constructor(
    private myService: ExportarDropboxService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.typeList = this.activatedRoute.snapshot.data['listExportTypes'];
    this.executionList = this.activatedRoute.snapshot.data['listExecution'];

    this.loaded();
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      fullpath: new FormControl('', [Validators.required]),
      type_id: new FormControl(null, [Validators.required]),
      filename: new FormControl({ value: null, disabled: true }),
      execution_id: new FormControl(null, [Validators.required]),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.get('fullpath').setValue(this.entity.fullpath);
      const type = this.typeList.find(item => item.id === this.entity.type_id);
      this.form.get('type_id').setValue(type);
      this.form.get('execution_id').setValue(this.entity.execution_id);
      this.atualizaFilename();
    }
  }

  voltar() {
    this.navigation.back(['projetos/exportar-dropbox']);
  }

  getDataCreate(): ExportarDropbox {
    let data: ExportarDropbox;
    data = Object.assign({}, data, this.form.value);
    data.type_id = data.type_id.id;
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res: ExportarDropbox) => {
              this.msgSuccess('Cadastro alterado com sucesso!');
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message)
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ExportarDropbox) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace(['projetos/exportar-dropbox/', res.id]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message)
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  atualizaFilename() {
    this.form.get('filename').setValue(this.form.get('type_id').value?.filename ? this.form.get('type_id').value?.filename : null);
  }
}
